var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8C9.06087 8 10.0783 7.57857 10.8284 6.82843C11.5786 6.07828 12 5.06087 12 4C12 2.93913 11.5786 1.92172 10.8284 1.17157C10.0783 0.421427 9.06087 0 8 0C6.93913 0 5.92172 0.421427 5.17157 1.17157C4.42143 1.92172 4 2.93913 4 4C4 5.06087 4.42143 6.07828 5.17157 6.82843C5.92172 7.57857 6.93913 8 8 8ZM8 10C6.44734 9.99883 4.91581 10.3598 3.52707 11.0541C2.13833 11.7485 0.930661 12.7572 0 14C0.930661 15.2428 2.13833 16.2515 3.52707 16.9459C4.91581 17.6402 6.44734 18.0012 8 18C9.55266 18.0012 11.0842 17.6402 12.4729 16.9459C13.8617 16.2515 15.0693 15.2428 16 14C15.0693 12.7572 13.8617 11.7485 12.4729 11.0541C11.0842 10.3598 9.55266 9.99883 8 10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserblack);
export default __webpack_public_path__ + "static/media/userblack.19b85cf45bb5bd66e668c115294cce02.svg";
export { ForwardRef as ReactComponent };